import configurationRanker from "./configurationRanker";
import { firstInFirstOutDistribute } from "./streampolicy/firstInFirstOutDistribute";
import { register as registerToSuggestionGroups } from "./toSuggestionGroups";
registerToSuggestionGroups();
/**
 * Creates a search box stream policy given a ranker.
 *
 * @param ranker The ranker.
 */
export default function createWithRanker(ranker) {
    return createWithRankerAndDistributor(ranker, firstInFirstOutDistribute);
}
/**
 * Creates a search box stream policy given a stream distributor.
 *
 * @param streamDistributor The stream distributor
 */
export function createWithDistributor(streamDistributor) {
    return createWithRankerAndDistributor(configurationRanker, streamDistributor);
}
/**
 * Creates a search box stream policy given a ranker and a stream distributor.
 *
 * @param ranker The ranker.
 * @param streamDistributor The stream distributor.
 */
export function createWithRankerAndDistributor(ranker, streamDistributor) {
    return function streamPolicy(groupsConfig, keySelector, streams, rxjs, rankProps) {
        var optimals = groupsConfig.map(function (c) { return c.optimalCount; });
        var maxes = groupsConfig.map(function (c) { return c.maxCount || Number.MAX_VALUE; });
        return (streamDistributor({ optimals: optimals, maxes: maxes }, keySelector, streams, rxjs) ||
            rxjs.Observable.empty())
            .toSuggestionGroups()
            .select(function (groups) {
            return ranker(groupsConfig, groups, rankProps);
        });
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlU3RyZWFtUG9saWN5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NyZWF0ZVN0cmVhbVBvbGljeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjQSxPQUFPLG1CQUFtQixNQUFNLHVCQUF1QixDQUFDO0FBQ3hELE9BQU8sRUFBRSx5QkFBeUIsRUFBRSxNQUFNLDBDQUEwQyxDQUFDO0FBQ3JGLE9BQU8sRUFBRSxRQUFRLElBQUksMEJBQTBCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUU5RSwwQkFBMEIsRUFBRSxDQUFDO0FBRTdCOzs7O0dBSUc7QUFDSCxNQUFNLENBQUMsT0FBTyxVQUFVLGdCQUFnQixDQUN0QyxNQUFjO0lBRWQsT0FBTyw4QkFBOEIsQ0FBQyxNQUFNLEVBQUUseUJBQXlCLENBQUMsQ0FBQztBQUMzRSxDQUFDO0FBRUQ7Ozs7R0FJRztBQUNILE1BQU0sVUFBVSxxQkFBcUIsQ0FDbkMsaUJBQTREO0lBRTVELE9BQU8sOEJBQThCLENBQUMsbUJBQW1CLEVBQUUsaUJBQWlCLENBQUMsQ0FBQztBQUNoRixDQUFDO0FBRUQ7Ozs7O0dBS0c7QUFDSCxNQUFNLFVBQVUsOEJBQThCLENBQzVDLE1BQWMsRUFDZCxpQkFBNEQ7SUFFNUQsT0FBTyxTQUFTLFlBQVksQ0FDMUIsWUFBc0QsRUFDdEQsV0FBZ0QsRUFDaEQsT0FBZ0QsRUFDaEQsSUFBVSxFQUNWLFNBQW9CO1FBRXBCLElBQU0sUUFBUSxHQUFHLFlBQVksQ0FBQyxHQUFHLENBQUMsVUFBQyxDQUFDLElBQUssT0FBQSxDQUFDLENBQUMsWUFBWSxFQUFkLENBQWMsQ0FBQyxDQUFDO1FBQ3pELElBQU0sS0FBSyxHQUFHLFlBQVksQ0FBQyxHQUFHLENBQUMsVUFBQyxDQUFDLElBQUssT0FBQSxDQUFDLENBQUMsUUFBUSxJQUFJLE1BQU0sQ0FBQyxTQUFTLEVBQTlCLENBQThCLENBQUMsQ0FBQztRQUV0RSxPQUNFLENBQUMsaUJBQWlCLENBQUMsRUFBRSxRQUFRLFVBQUEsRUFBRSxLQUFLLE9BQUEsRUFBRSxFQUFFLFdBQVcsRUFBRSxPQUFPLEVBQUUsSUFBSSxDQUFDO1lBQ2pFLElBQUksQ0FBQyxVQUFVLENBQUMsS0FBSyxFQUFFLENBQzFCO2FBQ0Usa0JBQWtCLEVBQUU7YUFDcEIsTUFBTSxDQUNMLFVBQUMsTUFBTTtZQUNMLE9BQUMsTUFBNEQsQ0FDM0QsWUFBWSxFQUNaLE1BQU0sRUFDTixTQUFTLENBQ3lCO1FBSnBDLENBSW9DLENBQ3ZDLENBQUM7SUFDTixDQUFDLENBQUM7QUFDSixDQUFDIn0=